<template>
    <ValidationObserver ref="validationObserver" slim>
        <div>
            <ProgressBar :currentStepIndex="2" />

            <div class="contentblock">
                <section class="contentblock__content">
                    <div class="pneu-offer__fieldgroup">
                        <div class="pneu-offer__fieldgroup-title">{{strings['PneuOffer.EnterAddress']}}</div>
                        <div class="pneu-offer__address-fields">
                            <AddressEditable :address="address"
                                             :showPhone="true"
                                             :showEmail="true"
                                             :showCumulus="false"
                                             :zipCityRules="null"
                                             :streetRules="null"
                                             @change="updateAddress" />
                            <div class="migrol-form__address-row">
                                <TextareaWithLabel :label="strings['PneuOffer.Remarks']" v-model="remarks" rows="5" />
                            </div>
                            <div class="migrol-form__address-row">
                                <DSE v-model="dseAccepted" />
                            </div>
                        </div>
                    </div>
                    <div class="pneu-offer__fieldgroup pneu-offer__fieldgroup--buttons">
                        <div class="pneu-offer__nav-buttons">
                            <button @click="back()" class="migrol-form__button" :disabled="validationPending">{{strings['Global.Back']}}</button>
                            <AjaxButton @buttonClick="next()" cssclass="migrol-form__button--green" :label="strings['Global.Continue']" :isWaitingForAjax="validationPending" />
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </ValidationObserver>
</template>

<script>
    import { mapState, mapMutations, mapGetters } from 'vuex';
    import ProgressBar from './_common/ProgressBar';
    import { ValidationObserver } from 'VeeValidate'
    import { doValidation } from '@/utils/utils'
    import * as gaTracking from "@/utils/gaTracking";

    export default {
        data() {
            return {
                validationPending: false
            }
        },
        computed: {
            ...mapState([
                'strings',
                'settings',
                'enums',

                //only temp:
                'salutation',
                'firstName',
                'lastName',
                'companyName',
                'street',
                'streetNumber',
                'addressLine2',
                'zipcode',
                'city',
                'phone',
                'emailAddress'
            ]),
            ...mapGetters([
                'address'
            ]),
            remarks: {
                get() { return this.$store.state.remarks; },
                set(text) { this.setRemarks(text); }
            },
            dseAccepted: {
                get() { return this.$store.state.dseAccepted; },
                set(newState) { this.setDseAccepted(newState); }
            }
        },
        methods: {
            ...mapMutations([
                'setRemarks',
                'setDseAccepted',
                'setAddress'
            ]),
            updateAddress(normalizedAddress) {
                this.setAddress(normalizedAddress);
            },
            back() {
                this.$router.push('/step2').catch(() => { });
            },
            next() {
                var vm = this;
                vm.validationPending = true;
                doValidation(
                    vm.$refs.validationObserver,
                    () => {
                        gaTracking.trackAddShippingInfo(this.$store.state);
                        vm.$router.push('/step4').catch(() => { });
                    },
                    () => {
                        vm.validationPending = false;
                    }
                );
            }
        },
        mounted() {
            gaTracking.trackBeginCheckout(this.$store.state);
            window.scrollTo({ top: 0, behavior: 'smooth' });
        },
        components: {
            ValidationObserver,
            ProgressBar
        }
    };
</script>